import { queryClient } from "../../../middlewares/cacheing/QueryClient.middleware";
import orderService from "../../../services/orders/order.service";
import { orderActionTypes } from "../../actionTypes/orders/order.actionTypes";

// Add Order
export const addOrder = (orderData) => async (dispatch) => {
  try {
    dispatch({ type: orderActionTypes.START_ADD_ORDER });
    const response = await orderService.addOrder(orderData);
    dispatch({
      type: orderActionTypes.ADD_ORDER_SUCCESS,
      data: response.data.payload,
    });
    // 0016: with the global 60s staleTime, the ["business-orders"] list would otherwise serve a
    // cached page missing the just-placed order when the user opens the orders page after checkout
    // (the cart navigates to /thank-you, so the list is viewed later, within staleTime). Invalidate
    // so the next mount of the orders table refetches. Mirrors the logout invalidation.
    queryClient.invalidateQueries({ queryKey: ["business-orders"] });
    return response.data; // Return server response
  } catch (ex) {
    console.error("Add order error:", ex.message);
    dispatch({
      type: orderActionTypes.ADD_ORDER_FAILURE,
      error: ex.response?.data,
    });
    throw ex.response?.data; // Return error
  }
};

export const fetchOrders = (filters) => async (dispatch) => {
  try {
    dispatch({ type: orderActionTypes.START_FETCH_ORDERS });

    const response = await orderService.fetchOrders(filters);
    dispatch({
      type: orderActionTypes.FETCH_ORDERS_SUCCESS,
      data: response.data.payload, // Assuming response contains a paginated list
    });

    return response.data; // Return server response
  } catch (ex) {
    console.error("Fetch orders error:", ex.message);

    dispatch({
      type: orderActionTypes.FETCH_ORDERS_FAILURE,
      error: ex.response?.data,
    });

    throw ex.response?.data; // Return error
  }
};

const orderActions = {
  addOrder,
  fetchOrders,
};

export default orderActions;
